import React from "react";
import { getCategoryBadgeStyle } from "../constants/categoryColors";

interface CategoryBadgeProps {
  category: string;
  className?: string;
}

const CategoryBadge: React.FC<CategoryBadgeProps> = ({
  category,
  className = "",
}) => {
  const badgeStyle = getCategoryBadgeStyle(category);

  return (
    <span
      className={`ml-2 inline-block rounded-full border border-black px-3 py-1 ${className}`}
      style={{
        backgroundColor: badgeStyle.backgroundColor,
        color: badgeStyle.color,
      }}
    >
      {category}
    </span>
  );
};

export default CategoryBadge;
